<script>
import { formtPriceBr } from '@core/utils/filter';
import { resolverColorById } from '@core/utils/utils';

export default {
  name: 'CardItem',
  methods: { resolverColorById },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  filters: {
    formtPriceBr,
  },
  data() {
    return {
      tableFields: [
        {
          key: 'item', label: '', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'pp', label: 'PP', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'p', label: 'P', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'm', label: 'M', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'g', label: 'G', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'gg', label: 'GG', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'xg', label: 'XG', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'xgg', label: 'XGG', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'unico', label: 'ÚNICO', headerClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'outros', label: 'OUTROS', headerClass: 'text-center', thClass: 'text-center',
        },
      ],
    };
  },
  computed: {
    calcularTotal() {
      const total = parseFloat(this.item.pedido_item_preco_unitario * this.item.pedido_item_quantidade).toFixed(2);
      this.item.valor_total = parseFloat(total);
      return total;
    },
    calcularTotalFinal() {
      const totalFinal = parseFloat(this.item.precoComImposto * this.item.pedido_item_quantidade).toFixed(2);
      this.item.valorTotalComImposto = parseFloat(totalFinal);
      return totalFinal;
    },
  },
  methods: {
    resolverColorById,
    preventInvalidInput(event) {
      if (event.key === '0' && event.target.value === '') {
        event.preventDefault();
      }
      if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E') {
        event.preventDefault();
      }
    },
    handleQuantityInput(event) {
      let newQuantity = parseInt(event) || 1;

      if (newQuantity < 1 || isNaN(newQuantity) || newQuantity === 0) {
        newQuantity = 1;
      }

      if (this.item.regra_pic === 'CS' && newQuantity > this.item.saldo) {
        newQuantity = this.item.saldo;
      }

      this.item.pedido_item_quantidade = newQuantity;

      this.$store.commit('PedidosStore/UPDATE_ITEM_QUANTITY', {
        item: this.item,
        quantity: newQuantity,
      });
    },

    incrementQuantity() {
      const maxQuantity = this.item.regra_pic === 'CS' ? this.item.saldo : 99999999;
      if (this.item.pedido_item_quantidade < maxQuantity) {
        this.item.pedido_item_quantidade += 1;
        this.handleQuantityInput(this.item.pedido_item_quantidade);
      }
    },

    decrementQuantity() {
      if (this.item.pedido_item_quantidade > 1) {
        this.item.pedido_item_quantidade -= 1;
        this.handleQuantityInput(this.item.pedido_item_quantidade);
      }
    },

    validateQuantity() {
      if (!this.item.pedido_item_quantidade || this.item.pedido_item_quantidade < 1) {
        this.item.pedido_item_quantidade = 1;
        this.handleQuantityInput(1);
      }
    },
  },
  watch: {
    'item.pedido_item_quantidade': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$store.commit('PedidosStore/UPDATE_ITEM_QUANTITY', {
            item: this.item,
            quantity: newVal,
          });
        }
      },
    },
  },
};
</script>

  <template>
    <b-card class="mb-1">
      <b-row class="m-0">
        <b-col cols="12" md="2" align-self="center" class="text-center">
          <b-img
              :src="item.item_imagem"
              fluid
              class="img-fluid"
              width="100px"
              height="100px"
          />
        </b-col>
        <b-col cols="12" md="5">
          <span class="item-title">{{ item.item_descricao }}</span>
          <div class="d-flex flex-column item-info-block">
            <span>
              <span class="text-color-item-cart label-strong">Preço:</span>
              <span class="item-price"> {{ item.precoComImposto | formtPriceBr }}</span>
            </span>
            <span class="text-color-item-cart">
              <strong>Marca:</strong>
              <span> {{ item.marca }}</span>
            </span>
            <span class="text-color-item-cart">
              <strong>Cor:</strong>
              <span> {{ item.des_cor }}</span>
            </span>
            <span class="text-color-item-cart">
              <strong>Tamanho:</strong>
              <span> {{ item.des_tamanho.toUpperCase() }}</span>
            </span>
            <span class="text-color-item-cart">
              <strong>Embalagem:</strong>
              <span> {{ item.embalagem }}</span>
            </span>
            <span class="text-color-item-cart">
              <strong>Cliente:</strong>
              <span> {{ item.cliente }}</span>
            </span>
            <span class="text-color-item-cart" v-if="item.item_pic_promocao">
              <b-badge variant="primary" class="mr-1">
                Promocional
              </b-badge>
            </span>
            <span class="text-color-item-cart" v-if="item.itemMultiplo">
              <b-badge variant="info" class="mr-1">
                Item múltiplo
              </b-badge>
            </span>
          </div>
        </b-col>
        <b-col
            cols="12"
            md="2"
            align-self="center"
        >
          <div v-if="item.regra_pic === 'QE' || item.picitemquantidade">
            <b-form-input
              v-model.number="item.pedido_item_quantidade"
              type="number"
              :min="item.saldo"
              :max="item.saldo"
              disabled
              class="text-center"
            />
          </div>
          <div v-else-if="item.regra_pic === 'CS'">
            <div class="quantity-control">
              <b-button size="sm" variant="outline-danger" class="btn-quantity"
                @click="decrementQuantity" :disabled="item.pedido_item_quantidade <= 1">
                <feather-icon icon="MinusIcon" size="14" />
              </b-button>
              <b-form-input
                v-model.number="item.pedido_item_quantidade"
                type="number"
                :min="1"
                :max="item.saldo"
                @input="handleQuantityInput"
                @blur="validateQuantity"
                @keydown="preventInvalidInput"
                class="text-center quantity-value"
              />
              <b-button size="sm" variant="outline-success" class="btn-quantity"
                @click="incrementQuantity" :disabled="item.pedido_item_quantidade >= item.saldo">
                <feather-icon icon="PlusIcon" size="14" />
              </b-button>
            </div>
          </div>
          <div v-else-if="item.itemMultiplo">
            <b-form-input
              v-model.number="item.pedido_item_quantidade"
              type="number"
              :min="item.saldo"
              :max="item.saldo"
              disabled
              class="text-center"
            />
          </div>
          <div v-else>
            <div class="quantity-control">
              <b-button size="sm" variant="outline-danger" class="btn-quantity"
                @click="decrementQuantity" :disabled="item.pedido_item_quantidade <= 1">
                <feather-icon icon="MinusIcon" size="14" />
              </b-button>
              <b-form-input
                v-model.number="item.pedido_item_quantidade"
                type="number"
                :min="1"
                :max="99999999"
                @input="handleQuantityInput"
                @blur="validateQuantity"
                @keydown="preventInvalidInput"
                class="text-center quantity-value"
              />
              <b-button size="sm" variant="outline-success" class="btn-quantity"
                @click="incrementQuantity">
                <feather-icon icon="PlusIcon" size="14" />
              </b-button>
            </div>
          </div>
        </b-col>
        <b-col
            cols="12"
            md="3"
            align-self="center"
            class="text-center"
        >
        <h4>{{ calcularTotalFinal | formtPriceBr }}</h4>
          <!-- <h4>{{ calcularTotal | formtPriceBr }}</h4> -->
          <!-- <small class="text-muted">
            Total final: {{ (item.valorTotalComImposto || item.precoComImposto) | formtPriceBr }}
          </small> -->
        </b-col>
      </b-row>
      <div class="actions-item">
        <feather-icon
            :id="`iconRemoverCart-${item.cdn_cor}-${item.cdn_tamanho}`"
            icon="Trash2Icon"
            class="mr-50 text-danger cursor-pointer"
            size="20"
            @click="$store.commit('PedidosStore/REMOVE_PRODUCT_ITEM_PEDIDO', item)"
        />
          <b-tooltip
              :target="`iconRemoverCart-${item.cdn_cor}-${item.cdn_tamanho}`"
              title="Remover do carrinho"
              placement="top"
          />
      </div>
    </b-card>
  </template>

<style scoped lang="scss">
.b-card {
  background: var(--sf-card-bg) !important;
  color: var(--sf-card-text) !important;
  border-color: var(--sf-card-border) !important;
}

.item-title {
  color: var(--sf-surface-text-dark) !important;
  font-weight: 700;
  font-size: 16px;
}

.item-info-block {
  padding-top: 5px;
}

.label-strong {
  font-weight: 700;
}

.item-price {
  color: var(--sf-accent) !important;
  font-weight: 700;
}

.quantity-control {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

  .btn-quantity {
    padding: 0.15rem 0.4rem;
    line-height: 1;
    min-width: 30px;
  }

  .quantity-value {
    min-width: 60px;
    text-align: center;
    font-weight: 600;
    margin: 0;
    background: var(--sf-form-bg) !important;
    border: 1px solid var(--sf-form-border) !important;
    color: var(--sf-form-text) !important;
    border-radius: 6px;
  }
}

.actions-item {
  position: absolute;
  right: 10px;
  top: 10px;
}

.text-center {
  text-align: center;
}

.form-group {
  margin-bottom: 0;
}

.form-control {
  width: 100%;
}

.table th, .table td {
  padding: 0 !important;
}

.text-color-item-cart {
  color: var(--sf-surface-muted) !important;
}
</style>
